import { UserProfile } from "@clerk/clerk-react";

export default function ProfilePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Profile</h1>
        <p className="text-lg text-gray-600">
          Manage your account settings and preferences
        </p>
      </div>
      
      <div className="bg-white p-8 rounded-lg border border-gray-200">
        <UserProfile
          routing="path"
          path="/profile"
          appearance={{
            elements: {
              // Root container
              rootBox: "mx-auto",
              card: "shadow-none border border-gray-200 rounded-lg bg-white",
              
              // Navigation
              navbar: "border-b border-gray-200",
              navbarButton: "text-gray-700 hover:text-trust-blue font-medium font-sans transition-colors",
              navbarButtonActive: "text-trust-blue border-b-2 border-trust-blue font-medium font-sans",
              
              // Header
              headerTitle: "text-2xl font-bold text-gray-900 font-sans",
              headerSubtitle: "text-gray-600 font-sans",
              
              // Form elements
              formButtonPrimary: 
                "bg-trust-blue hover:bg-trust-blue-700 text-white font-medium rounded-lg transition-all shadow-sm hover:shadow-md focus-visible:ring-2 focus-visible:ring-trust-blue focus-visible:ring-offset-2",
              formButtonSecondary:
                "border-gray-200 hover:bg-gray-50 text-gray-700 font-medium rounded-lg transition-all font-sans",
              formFieldInput: 
                "border-gray-200 focus:border-trust-blue focus:ring-2 focus:ring-trust-blue focus:ring-offset-2 rounded-md font-sans",
              formFieldLabel: 
                "text-gray-700 font-medium font-sans",
              formFieldInputShowPasswordButton:
                "text-gray-500 hover:text-gray-700",
              
              // Links
              formButtonReset: 
                "text-gray-600 hover:text-gray-900 font-medium font-sans",
              identityPreviewEditButton:
                "text-trust-blue hover:text-trust-blue-700 font-medium",
              formResendCodeLink:
                "text-trust-blue hover:text-trust-blue-700 font-medium",
              
              // Cards and sections
              cardBox: "border border-gray-200 rounded-lg",
              page: "font-sans",
              
              // Alert/Error messages
              alertText: "font-sans",
              formFieldErrorText: "text-critical-red font-sans",
              
              // Other elements
              otpCodeFieldInput: 
                "border-gray-200 focus:border-trust-blue focus:ring-2 focus:ring-trust-blue rounded-md font-sans",
              badge: "bg-trust-blue text-white",
              avatarBox: "rounded-full",
            },
            variables: {
              colorPrimary: "#2563EB",
              colorText: "#1F2937",
              colorTextSecondary: "#6B7280",
              colorInputText: "#1F2937",
              colorInputBackground: "#FFFFFF",
              colorBorder: "#E5E7EB",
              colorDanger: "#DC2626",
              borderRadius: "0.5rem",
              fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
              fontSize: "1rem",
            },
          }}
        />
      </div>
    </div>
  );
}

